
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Facebook, Twitter, Linkedin, Share2 } from 'lucide-react';

export const FloatingSocialWidget = () => {
  const [expanded, setExpanded] = useState(false);
  
  const handleShare = (platform: string) => {
    const url = window.location.href;
    const title = document.title;
    let shareUrl = '';
    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);
    
    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
        break;
    }
    
    if (shareUrl) {
      window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=400');
    }
  };
  
  return (
    <div className="fixed bottom-10 right-6 z-50 transition-opacity duration-300 ease-in-out opacity-100">
      <div className="flex flex-col items-center space-y-2">
        {expanded && (
          <div 
            className="flex flex-col space-y-2 mb-2 transition-all duration-300"
            style={{ 
              animation: expanded ? 'fadeIn 0.3s ease-out forwards' : 'none'
            }}
          >
            <Button 
              variant="outline" 
              size="icon" 
              className="h-10 w-10 rounded-full bg-white text-blue-600 hover:bg-blue-100 shadow-md"
              onClick={() => handleShare('facebook')}
            >
              <Facebook className="h-5 w-5" />
              <span className="sr-only">Share on Facebook</span>
            </Button>
            <Button 
              variant="outline" 
              size="icon" 
              className="h-10 w-10 rounded-full bg-white text-blue-500 hover:bg-blue-100 shadow-md"
              onClick={() => handleShare('twitter')}
            >
              <Twitter className="h-5 w-5" />
              <span className="sr-only">Share on Twitter</span>
            </Button>
            <Button 
              variant="outline" 
              size="icon" 
              className="h-10 w-10 rounded-full bg-white text-blue-700 hover:bg-blue-100 shadow-md"
              onClick={() => handleShare('linkedin')}
            >
              <Linkedin className="h-5 w-5" />
              <span className="sr-only">Share on LinkedIn</span>
            </Button>
          </div>
        )}
        
        <Button 
          size="icon" 
          className="h-12 w-12 rounded-full shadow-md bg-gaming-blue hover:bg-gaming-blue/80 transition-transform duration-200"
          onClick={() => setExpanded(!expanded)}
        >
          <Share2 className="h-5 w-5" />
          <span className="sr-only">Share this page</span>
        </Button>
      </div>
    </div>
  );
};
